import * as _4 from 'lodash4';
import { ICourseGrupInfo } from '../../components/smart_search/smart_catalog_search';
import { ApSmartSearchServant } from '../../servants/ap_smart_search_servant';
import { usermode } from '../../types/smart_search_user_modes';
import { smartCatalogConfiguration } from '../search_prefab_configuration';

const courseGroupSearchActions = (actions: any, CourseGroupSearchInfo: ICourseGrupInfo) => {
  const _courseGroupSearchActions = { ...actions };
  const isLocked = ApSmartSearchServant.isCoursegroupLocked(CourseGroupSearchInfo);
  const planButtonTitle = ApSmartSearchServant.isInSwapMode(CourseGroupSearchInfo) ? 'Swap' : 'Plan';
  if (ApSmartSearchServant.isPlanningFromTerm(CourseGroupSearchInfo) && !isLocked) {
    _courseGroupSearchActions['Plan_to_term'] = {
      name: 'Plan_to_term',
      $widget: {
        $behavior: 'operation',
        title: planButtonTitle,
        kind: 'secondary',
        $region: 'course_plan_region',
        input_mode: 'singular'
      },
      $do: '(( plan_to_term_action ))'
    };
    _courseGroupSearchActions['plan_to_term_action'] = {
      kind: 'plan_to_term_action'
    };
  }
  return _courseGroupSearchActions;
};

export const largeCourseGroupSmartSearchConfiguration = (
  userMode: usermode,
  CourseGroupSearchInfo: ICourseGrupInfo
) => {
  const { courseGroupValue } = CourseGroupSearchInfo;
  const basicSmartSearchConfiguration = smartCatalogConfiguration(userMode);
  const _largeCourseGroupSmartSearchConfiguration = { ...basicSmartSearchConfiguration };
  _largeCourseGroupSmartSearchConfiguration.action = courseGroupSearchActions(
    _largeCourseGroupSmartSearchConfiguration.action,
    CourseGroupSearchInfo
  );
  const {
    bucket: { context }
  } = _largeCourseGroupSmartSearchConfiguration;
  context.$reactive_values['results_title'] = `results found for ${_4.get(
    CourseGroupSearchInfo,
    'parentCourse.programSlot.desc',
    ''
  )}`;
  const { configuration } = _largeCourseGroupSmartSearchConfiguration;
  if (!ApSmartSearchServant.isWildcardSmartSearch(CourseGroupSearchInfo)) {
    configuration['course_group_value'] = { course_groups: courseGroupValue };
  }
  if (!ApSmartSearchServant.isWildcardSmartSearch(CourseGroupSearchInfo)) {
    const _finishEvents: string[] = _largeCourseGroupSmartSearchConfiguration.life_cycle.initialize.$finish;
    _finishEvents.push('=>> ((search_action)) <=< configuration.course_group_value');
  }
  return _largeCourseGroupSmartSearchConfiguration;
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/configuration/large_course_group_smart_search/large_course_group_smart_search_configuration.ts